export enum UserType {
    User,
    Role,
    Level,
    Keyword,
    UserGroup
}

export interface MixedUserChoice {
    type: UserType;
    name: string;
    originalObject: any;
}